const SocketQos = {
  AT_MOST_ONCE: 0, // Fire and forget
  AT_LEAST_ONCE: 2, // Make sure the message is received at least once
};

export default SocketQos;
